<template>
  <UIModal
    v-model="open"
    back-button
    close-button
    transparent
    :blured="false"
    :fix-header="true"
    @back="open = false"
    @click="open = false"
  >
    <template #header>
      <div class="modal-header">{{ $t('halloweenNavigationButtonTeam') }}</div>
    </template>

    <div class="modal-body">
      <div class="modal-body-container">
        <UIHalloweenCharacter v-for="character in characters" :key="character.characterType" :character="character" />
      </div>
    </div>
  </UIModal>
</template>
<script lang="ts" setup>
import UIHalloweenCharacter from '~/components/Halloween/ui/UIHalloweenCharacter.vue';
import type { ExpeditionExtendedState } from '~/types/halloween/expedition';

const open = defineModel<boolean>({ required: true });
defineProps<{
  characters: ExpeditionExtendedState['characters'];
}>();
</script>
<style scoped>
.modal-body {
  width: 900px;
  max-width: 100%;
  height: 650px;
  position: relative;
  display: block;
  border-radius: 0.75rem;
  @media screen and (max-width: 640px) {
    height: 100vh;
  }
}

.modal-header {
  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  font-family: Grenze, serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
}

.modal-body-container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 10px;
  overflow: hidden;
  overflow-y: auto;

  @media screen and (max-width: 640px) {
    flex-wrap: wrap;
    max-height: calc(100vh - 76px);
    transform: translateY(76px);
  }
}
</style>
